import React from 'react';

import { CatalystInsightPill } from '~/widgets/catalyst-insights-drawer/catalyst-insight-pill/CatalystInsightPill';
import { useCatalystDrawer } from '~/widgets/catalyst-insights-drawer/useCatalystDrawer';

import * as S from './InsightTypePill.styles';
import { constructMetadataSentence } from './utils';

export interface InsightTypePillProps {
  createdAt: string;
  updatedAt?: string;
}

export const InsightTypePill = ({
  createdAt,
  updatedAt,
}: InsightTypePillProps) => {
  const { insightId } = useCatalystDrawer();

  if (!insightId) {
    return null;
  }

  return (
    <S.Container>
      <CatalystInsightPill insightId={insightId} />
      <S.MetadataText>
        {constructMetadataSentence({
          createdAt,
          updatedAt,
        })}
      </S.MetadataText>
    </S.Container>
  );
};
